// this is an autogenerated file from App/Account/Content/Tasks/mutation-create-task-comment.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks($task_id: uuid!, $comment: String!) {
  insert_tasks_comments_one(object: { task_id: $task_id, value: $comment }) {
    id
  }
}

`